export default __webpack_public_path__ + "58606f2b4677b4a325a6acd4214a9c97.jpg";